import React, { useEffect, useState, useRef } from 'react';
const useComponentVisible = ({initialIsVisible}) => {
	const [isComponentVisible, setIsComponentVisible] = useState(
	  initialIsVisible
	);
	const refrence = useRef(null);
  
	const handleHideDropdown = (event: KeyboardEvent) => {
	  if (event.key === "Escape") {
		setIsComponentVisible(false);
	  }
	};
	const handleClickOutside = event => {
	  if (refrence.current && !refrence.current.contains(event.target)) {
		setIsComponentVisible(false);
	  }
	};
  
	useEffect(() => {
	  document.addEventListener("keydown", handleHideDropdown, true);
	  document.addEventListener("click", handleClickOutside, true);
	  return () => {
		document.removeEventListener("keydown", handleHideDropdown, true);
		document.removeEventListener("click", handleClickOutside, true);
	  };
	});
  
	return { refrence, isComponentVisible, setIsComponentVisible };
  }

  export default useComponentVisible;